import styled from 'styled-components'

export const SkeletonRoot = styled.div`
    overflow: hidden;
    border-radius: 22px;
    display: flex;
    flex-direction: column;
`;

export const HeroSkeleton = styled.div`
    min-height: 410px;
    padding: clamp(58px, 8vw, 104px) clamp(22px, 5vw, 74px);
    background: ${({ theme }) => theme.palette.colors.surfaceElevatedStrong};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 18px;
`;

export const SectionSkeleton = styled.div`
    padding: clamp(54px, 7vw, 94px) clamp(22px, 5vw, 74px);
    background: ${({ theme }) => theme.palette.colors.background};
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const CardSkeletons = styled.div`
    width: 100%;
    max-width: 1120px;
    margin-top: 38px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 22px;

    @media (max-width: 840px) { grid-template-columns: 1fr; }
`;
